import { impersonationEmailAtom } from "common/lib/atoms"
import { useRecoilState } from "recoil"

export default function useImpersonationEmail() {
    return useRecoilState(impersonationEmailAtom)
}
